import axios from 'axios';
import { useAuth } from './authContext';
import { resetClient } from './twilioSync';
import { resetUserInfo } from './userInfo';

const useSignOut = () => {
  const { removeSession } = useAuth();

  const signOut = async () => {
    try {
      await axios.post('/api/signout');
    } catch (err) {
      console.warn('Sign out API call failed: ', err);
    }
    removeSession(true);
    resetClient();
    resetUserInfo();
  };

  return signOut;
};

export default useSignOut;
